const projects = () => {
    if ($(".projects").length) {
       

        $(".showmore").on("click", function () {
            $wrapper = $(this).parent().find(".more-detail");
            $wrapper.css({
                height: $(this).hasClass("up") ? 0 : $wrapper.find(".row").height()
            });
            $(this).toggleClass("up");
        })
    }
}

module.exports = projects
